import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=643ec4ca&"
import script from "./Navigate.vue?vue&type=script&lang=js&"
export * from "./Navigate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSpinnerAudio} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerAudio})
